<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
  <div class="container-fluid">
    <!-- Brand -->
    <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" routerLinkActive="active" [routerLink]="['/dashboard']">{{getTitle()}}</a>

    <!-- User -->
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link pr-0" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="assets/img/user-default.jpg">
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{usuarioLogado?.nome}}</span>
            </div>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
         <!--
         <div class=" dropdown-header noti-title">
            <h6 class="text-overflow m-0">Olá!</h6>
          </div>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Configurações</span>
          </a>
          <div class="dropdown-divider"></div>-->
          <a [routerLink]="['/alterar-senha']" class="dropdown-item">
            <i class="ni ni-key-25"></i>
            <span>Cambiar contraseña</span>
          </a>
          <a (click)="logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Salir</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
